


















































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component } from 'vue-property-decorator';
import ConsultResponseService from '@/services/pickcook/consult-response.service';
import {
  ConsultResponseDto,
  ConsultResponseListDto,
  ProductConsultStatusUpdateDto,
} from '@/dto';
import { Pagination } from '@/common';
import {
  BRAND,
  BRAND_CONSULT,
  CONST_BRAND_CONSULT,
  CONST_FNB_OWNER,
  CONST_PAGINATION_COUNT,
  CONST_RESERVATION_DELETE_REASON,
  FNB_OWNER,
  PaginationCount,
  RESERVATION_DELETE_REASON,
} from '@/services/shared';
import { getStatusColor } from '@/core/utils/status-color.util';
import CommonCodeService from '@/services/pickcook/common-code.service';
import { PickcookCodeManagementDto } from '@/services/init/dto';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'ConsultResponseList',
})
export default class ConsultResponseList extends BaseComponent {
  private consultResponseList: ConsultResponseDto[] = [];
  private consultResponseSerchDto = new ConsultResponseListDto();
  private pagination = new Pagination();
  private consultResponseTotalCount = null;
  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];
  private searchPramsDto: any = {};

  private dataLoading = false;
  private fnbOwnerStatus: PickcookCodeManagementDto[] = [];
  private consultStatus: PickcookCodeManagementDto[] = [];
  private codeManagementDto = new PickcookCodeManagementDto();
  private paginationCode = new Pagination();

  private reservationDeleteReasons: RESERVATION_DELETE_REASON[] = [
    ...CONST_RESERVATION_DELETE_REASON,
  ];

  private selectedProductConsultNos: number[] = [];
  private consultStatusUpdateDto = new ProductConsultStatusUpdateDto();
  private newDate = new Date();

  // excel options
  private fields = {
    ID: 'id',
    이름: 'name',
    나이: 'ageGroupCodeStatus.displayName',
    연락처: 'phone',
    미팅예약날짜: 'reservation.reservationDate',
    미팅예약시간: 'reservation.reservationTime',
    미팅취소사유: 'reservation.deleteReason',
    취소기타사유: 'reservation.deleteReasonEtc',
    담당자: 'admin.name',
    신청상태: 'consultCodeStatus.comment',
    신청일: 'created',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  // get status color
  getStatusColor(status: BRAND_CONSULT) {
    return getStatusColor(status);
  }

  // get common codes
  getCommonCodes() {
    this.codeManagementDto.category = 'FNB_OWNER';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.fnbOwnerStatus = res.data.items;
    });

    this.codeManagementDto.category = 'BRAND_CONSULT';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.consultStatus = res.data.items;
    });
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    this.pagination.limit = this.newLimit;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.consultResponseSerchDto, this.pagination);
    }

    ConsultResponseService.findAll(
      this.consultResponseSerchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.consultResponseList = res.data.items;
        this.consultResponseTotalCount = res.data.totalCount;
      }
    });
  }

  search() {
    this.findAll(true, true);
  }

  paginateSearch() {
    this.findAll(true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.consultResponseSerchDto = new ConsultResponseListDto();
      this.findAll();
    }
  }

  created() {
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.consultResponseSerchDto = query;
      this.pagination.page = +query.page;
      this.newLimit = +query.limit;
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCommonCodes();
  }
}
